import type { Messages } from '../de';

export default {
  title: 'Activities',
  kicker: { one: '{count} activity {period}', other: '{count} activities {period}' },
  periodAll: 'in total',
  periodYear: 'in {year}',
  search: 'Search',
  searchClose: 'Close search',
  searchLabel: 'Search title and note',
  searchPlaceholder: 'Title, note …',
  kpis: 'Key figures',
  kpi: { distance: 'Distance', time: 'Time', elevation: 'Elevation', count: 'Count' },
  kpiCount: { one: '{count} activity', other: '{count} activities' },
  zugspitzen: '{n}× Zugspitze',
  estimatedSome: '{n} of them with estimated load',
  estimatedNone: 'all with measured load',
  filter: 'Filter',
  sportGroup: 'Sport',
  all: 'All',
  source: 'Source',
  sourceFit: 'Wahoo / FIT',
  sourceStrava: 'Strava export',
  year: 'Year',
  listFailed: 'List not loaded: {error}',
  list: 'List',
  col: {
    date: 'Date',
    activity: 'Activity',
    distance: 'Distance',
    time: 'Time',
    pace: 'Pace / speed',
    hr: 'Avg HR',
    load: 'Load',
    source: 'Source',
  },
  loadEstimatedTip: 'estimated – no heart rate',
  hasMedia: { one: '{count} photo', other: '{count} photos' },
  avgBpm: '{hr} bpm',
  noHr: 'no HR',
  footerCount: '{shown} of {total} {period}',
  footerLegend: '“~” = estimated load (no heart rate)',
  loading: 'Loading …',
  more: 'Load more',
  empty: 'No activities for this filter.',
  upload: {
    created: 'Created.',
    known: 'Already known – nothing changed.',
    withSource: 'the {source} {noun}',
    nounRide: 'ride',
    nounActivity: 'activity',
    withExisting: 'the existing activity',
    primaryFit: ' The uploaded file now provides the data.',
    primaryOther: ' Data stays from {source}.',
    merged: 'Merged with {with}.{primary}',
    failed: 'Upload failed: {error}',
    busy: 'Loading …',
    button: 'Upload FIT',
    buttonLong: 'Upload FIT file',
    view: 'View',
  },
  src: {
    strava: 'Strava export',
    fit: 'FIT upload',
    user: 'you',
    tipGarmin: 'Garmin Personal API',
    tipStrava: 'from the Strava export',
    tipUpload: '{main}, uploaded manually',
    replaces: '{main} replaces {others} version ({why})',
    and: ' and ',
    whyRide: 'ride priority',
    why: 'source priority',
    titleAndNote: 'Title and note from {s}',
    titleFrom: 'Title from {s}',
    noteFrom: 'Note from {s}',
    dataFrom: 'Data from {s}',
  },
  fallback: {
    title: '{part} {sport}',
    sport: {
      run: 'run',
      ride: 'ride',
      swim: 'swim',
      yoga: 'yoga',
      strength: 'strength training',
      hike: 'hike',
      walk: 'walk',
      other: 'activity',
    },
    morning: 'Morning',
    noon: 'Lunch',
    afternoon: 'Afternoon',
    evening: 'Evening',
  },
  longDate: '{wd}, {d} {month} {y}',
} satisfies Messages['activities'];
